import type { AgentComponentToolOption } from '@reach/shared-types/agent-components';
import { TOOLS_FIELD_COPY } from './component-page-copy';

/** A tool's display name as a phrase: "find_open_times" reads "Find open times". */
export const toolLabel = (displayName: string): string => {
  const phrase = displayName.replaceAll('_', ' ').trim();
  return phrase.charAt(0).toUpperCase() + phrase.slice(1);
};

/** How the tool reaches the partner's system, such as "GET /availability". */
export const toolRequestLabel = ({ http }: AgentComponentToolOption): string =>
  http ? `${http.method} ${http.path}` : TOOLS_FIELD_COPY.lookupTool;
